import React from 'react';
import { useAspSelector } from '../../../../test/jest-redux-hooks';
import ApiKeysComponent from '../../components/ApiKeys';

const ApiKeys = () => {
  const { currentBrand } = useAspSelector((state) => state?.app);
  console.log(currentBrand, "currentBrand");
  
  return (
    <div className="w-full h-full p-6">
      <ApiKeysComponent brandId={currentBrand?.brand_slug} />
    </div>
  );
};

export default ApiKeys;
